import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  eyebrow: string;
  title: React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`flex flex-col ${alignment} ${className}`} data-id="element-121" data-mp="bjtw9t0qii0j">
      <p className="mb-4 font-sans text-xs uppercase tracking-[0.3em] text-sage" data-id="element-122" data-mp="6rtz28c1u37n">
        {eyebrow}
      </p>
      <h2 className="font-serif text-4xl leading-tight text-ink md:text-5xl" data-id="element-123" data-mp="uhelx2bbpkm7">
        {title}
      </h2>
    </motion.div>;
}